/**
 * Qué dice el chip de búsqueda que se está buscando. Con un operador (`asunto: x`, `de: ana`…) el servidor
 * busca SOLO en ese campo (server.py `_operador_busqueda`), pero el chip seguía diciendo «asunto, remitente
 * y contenido». Mismos operadores y misma forma que el backend: al principio y con dos puntos.
 */
const CAMPO = {
  from: 'remitente', de: 'remitente',
  to: 'destinatarios', para: 'destinatarios', cc: 'destinatarios',
  subject: 'asunto', asunto: 'asunto',
  body: 'contenido', cuerpo: 'contenido',
};

export function alcanceBusqueda(texto, { profunda, buscando } = {}) {
  const m = String(texto || '').trim().match(/^(from|de|to|para|cc|subject|asunto|body|cuerpo):\s*\S/i);
  if (m) return `solo ${CAMPO[m[1].toLowerCase()]}`;
  if (!profunda) return 'asunto y remitente';
  return buscando ? 'buscando también en el contenido…' : 'asunto, remitente y contenido';
}
